import person from '../../Assets/Imgs/person.png'

const AvatarOne = ({ src, height, width, maxWidth, maxHeight, margin, corAvatar, retrato = false, borda = true, ...props }) => {
    const handleOnError = (e) => {
        e.target.onerror = null
        e.target.src = person
    }
    return (
        <div
            style={{
                display: 'flex',
                maxHeight,
                maxWidth
            }}
        >
            {src
                ? (<img
                    src={src}
                    height={height}
                    width={width}
                    style={{
                        borderRadius: retrato ? '0' : '50%',
                        border: retrato || !borda ? '0' : '1px solid black',
                        margin,
                        maxWidth,
                        maxHeight
                    }}
                    onError={handleOnError}
                    align="center"
                    {...props}
                />)
                : (<img
                    src={person}
                    height={height}
                    width={width}
                    style={{
                        borderRadius: '50%',
                        border: '1px solid black',
                        maxWidth,
                        maxHeight
                    }}
                    {...props}
                />)
            }
        </div>
    )
}

export default AvatarOne
